<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eljqGS/tc-custom/9781613122112.jpg?1699136480989" alt="This image is the cover for the book British Table"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">British Table
      </h1>
      <p class="bookDescription body article font2">
        <b>From a James Beard Award–winning author, a fresh take on traditional recipes from England, Scotland and Wales.</b><br/>  <br/><i>The British Table: A New Look at the Traditional Cooking of England, Scotland, and Wales</i> celebrates the best of British cuisine old and new. Drawing on a vast number of sources, both historical and modern, the book includes more than 150 recipes, from traditional regional specialties to modern gastropub reinventions of rustic fare. Dishes like fish pie, braised brisket with pickled walnuts, and a pastry shop full of simple, irresistible desserts have found their way onto modern British menus—delicious reminders of Britain’s culinary heritage. The book blends these tradition-based reinventions by some of the finest chefs in England, Scotland, and Wales with forgotten dishes of the past worthy of rediscovery.<br/>  <br/> “Colman Andrews[‘s] writing changes the way I cook, and I look forward to every book. <i>The British Table</i> is no exception.” –Alice Waters, founder of Chez Panisse and The Edible Schoolyard<br/>  <br/> “Leafing through these beautiful pages of unfussy food, I find myself wanting to cook everything, eat everything—or just climb on the first plane to England.” –Ruth Reichl, former editor-in-chief of <i>Gourmet</i> and author of <i>My Kitchen Year</i><br/>  <br/> “Both a lovely and a loving book.” –Nigella Lawson, host of <i>Simply Nigella </i>and author of the award-winning cookbook, <i>How to Be a Domestic Goddess</i><br/>  <br/> Colman Andrews is the recipient of eight James Beard Awards, including the 2010 Cookbook of the Year award for <i>The Country Cooking of Ireland</i>. A founding editor of <i>Saveur</i>, he is the author of several books on food. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Colman Andrews, Christopher Hirsheimer, Melissa Hamilton
      </h2>
      
      <p class="authorDescription body article">Colman Andrews is the recipient of eight James Beard Awards, including the 2010 Cookbook of the Year award for The Country Cooking of Ireland. A founding editor of Saveur, he is the author of eight previous books on food, including Catalan Cuisine, Ferran: The Inside Story of El Bulli and the Man Who Reinvented Food, and My Usual Table: A Life in Restaurants, a memoir. He lives in Connecticut.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ABRAMS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a7db2ea